// extracted by css-extract-rspack-plugin
export default {"loginCommand":"loginCommand__yEVJL","loginButton":"loginButton__03fzN"};